import styled from 'styled-components';

const Table = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

const Row = styled.div`
	width: 100%;
	display: flex;

	&:nth-child(even) {
		background-color: rgba(0,0,0,0.05);
	}
`;

const Cell = styled.div`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	flex-grow: 1;
	height: 24px;
	padding: 0 8px;
	overflow: hidden;
	justify-content: ${params => params.end ? 'flex-end' : 'none'};
	text-align: ${params => params.end ? 'right' : 'left'};
	list-style: none;
	white-space: nowrap;
`;

const Heading = styled(Cell)`
	font-weight: bold;
`;

export {
	Table,
	Row,
	Cell,
	Heading,
}
